//View Keys
export default {
  realtimemaps_vehicletrails_trails: "Rastros de vehículos",
  realtimemaps_vehicletrails_trips: "Viajes de vehículos",
  realtimemaps_vehicletrails_settings: "Configuración",
  realtimemaps_vehicletrails_unit: "Unidad",
  realtimemaps_vehicletrails_date: "Fecha / Hora",
  realtimemaps_vehicletrails_event: "Evento",
  realtimemaps_vehicletrails_latitude: "Latitud",
  realtimemaps_vehicletrails_longitude: "Longitud",
  realtimemaps_vehicletrails_filter: "Filtro",
  realtimemaps_vehicletrails_allevents: "- Todos los Eventos -",
  realtimemaps_vehicletrails_gettrail: "Obtener la Ruta",
  realtimemaps_vehicletrails_gettrail_infoBubble: "Rastro del Vehículo",
  realtimemaps_vehicletrails_nodata:
    "No hay datos disponibles para el periodo solicitado",
  realtimemaps_vehicletrails_closetable: "Cerrar Tabla De Rutas",
  realtimemaps_vehicletrails_closesettings: "Cerrar Configuración",
  realtimemaps_vehicletrails_vehicletrail_table:
    "Ver Tabla De Rutas De Vehículos",
  realtimemaps_vehicletrails_vehicletrail_view: "Tabla de Rutas de Vehículos",
  realtimemaps_vehicletrails_vehicletrail_err:
    "ha ocurrido una incidencia en la carga. por favor intente nuevamente.",
  realtimemaps_vehicletrails_vehicletrail_validatedate:
    "El rango de fechas no puede exceder a 30 dias",
  realtimemaps_vehicletrails_vehicletrail_validateunit:
    "La Unidad es un campo obligatorio",
  realtimemaps_vehicletrails_no_activity_dates: "No hay fechas de actividad",
  realtimemaps_vehicletrails_no_trips: "No hay viajes",
  realtimemaps_vehicletrails_trip_hrs: "hrs",
  realtimemaps_vehicletrails_trip_mins: "mins",
  realtimemaps_vehicletrails_trip_miles: "millas",
  realtimemaps_vehicletrails_trip_stops: "paradas",
  realtimemaps_vehicletrails_trip_io_events: "Eventos E/S",
  realtimemaps_vehicletrails_requestvideo: "Solicitar Video",
  realtimemaps_vehicletrails_empty_state: "Haga clic en la ruta del vehículo o en la línea de tiempo para identificar el segmento de video de interés.",
  realtimemaps_vehicletrails_from: "Desde",
  realtimemaps_vehicletrails_to: "Hasta",
  realtimemaps_vehicletrails_duration: "Duración",
  realtimemaps_vehicletrails_submit: "Enviar",
  realtimemaps_vehicletrails_error_creating_clip: "Este rango de tiempo ya fue solicitado anteriormente, por favor seleccione otro rango de tiempo.",
  realtimemaps_vehicletrails_error_creating_clip_warning: "Advertencia",  
  realtimemaps_vehicletrails_clip_created_successfully: "La solicitud de video se ha creado correctamente",
  realtimemaps_vehicletrails_export: "Exportar",
  realtimemaps_vehicletrails_export_title: "Viajes de Vehículos",
  realtimemaps_vehicletrails_export_event_ignition_on: "Encendido",
  realtimemaps_vehicletrails_export_event_ignition_off: "Apagado",
  realtimemaps_vehicletrails_export_filename: "viajes-vehiculos",
  realtimemaps_vehicletrails_date_prev: "Fecha anterior",
  realtimemaps_vehicletrails_date_next: "Fecha siguiente",
  // Clip request form - resolution, style, camera view
  realtimemaps_vehicletrails_cliprequest_resolution: "Resolución",
  realtimemaps_vehicletrails_cliprequest_style: "Estilo",
  realtimemaps_vehicletrails_cliprequest_cameraView: "Vista de cámara",
  realtimemaps_vehicletrails_cliprequest_placeholder_resolution: "Seleccionar resolución",
  realtimemaps_vehicletrails_cliprequest_placeholder_style: "Seleccionar estilo",
  realtimemaps_vehicletrails_cliprequest_placeholder_cameraView: "Seleccionar vista",
  realtimemaps_vehicletrails_cliprequest_resolution_sd: "SD",
  realtimemaps_vehicletrails_cliprequest_resolution_hd: "HD",
  realtimemaps_vehicletrails_cliprequest_style_road: "Carretera",
  realtimemaps_vehicletrails_cliprequest_style_sideBySide: "Lado a lado",
  realtimemaps_vehicletrails_cliprequest_style_pictureInPicture: "Imagen en imagen",
  realtimemaps_vehicletrails_cliprequest_style_driver: "Conductor",
  realtimemaps_vehicletrails_cliprequest_style_separate: "Separado",
  realtimemaps_vehicletrails_cliprequest_cameraView_road: "Carretera",
  realtimemaps_vehicletrails_cliprequest_cameraView_driver: "Conductor",
};
